import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteBook = async (ID) => {
  try {
    const BookDocument = doc(db, "Library", ID);

    await updateDoc(BookDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteBook;
